import { createSyncClientFlag } from "@/lib/core/client-flags/create-sync-client-flag";

export const useReachOutReviewStripEnabled = createSyncClientFlag({
    param: "reachOutReviewStrip",
    key: "reach-out-review-strip",
    env: import.meta.env.VITE_PUBLIC_REACH_OUT_REVIEW_STRIP !== "false",
});
